"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Text4 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Loading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Loading"));
var _Heading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Heading"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Box2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _react = require("react");
var _reactIntl = require("react-intl");
var _Edit = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Edit"));
var _CheckCircle2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/CheckCircle"));
var _Check = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Check"));
var _Logo = _interopRequireDefault(require("../../../Logo"));
var _context = require("../../../../services/brand/context");
var _OTPForm = _interopRequireDefault(require("./OTPForm"));
var _apiV = require("../../../../services/auth/apiV2");
var _index = require("../../../../services/auth/index");
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _usePublishPhoneVerificationOtpEditPhoneNumberButtonClicked = _interopRequireDefault(require("../../consts/events/business/usePublishPhoneVerificationOtpEditPhoneNumberButtonClicked"));
var _usePublishPhoneVerificationPhoneCallOtpScreenDisplayed = _interopRequireDefault(require("../../consts/events/business/usePublishPhoneVerificationPhoneCallOtpScreenDisplayed"));
var _usePublishPhoneVerificationOtpResendButtonClicked = _interopRequireDefault(require("../../consts/events/business/usePublishPhoneVerificationOtpResendButtonClicked"));
var _events = require("../../consts/events");
var _context2 = require("../../../../services/log/context");
var _jsxRuntime = require("react/jsx-runtime");
var _Heading, _Text, _FormattedMessage, _Box, _FormattedMessage2, _Loading, _Text2, _CheckCircle, _Text3;
const PhoneCallOtp = _ref => {
  let {
    phone,
    onChangeScreen,
    otpTransactionId,
    onOtpTransactionIdChange,
    onPhoneVerificationFulfilled,
    setPhoneVerificationRetryTime,
    setPhoneVerified
  } = _ref;
  const [timer, setTimer] = (0, _react.useState)(60);
  const [error, setError] = (0, _react.useState)(null);
  const [phoneCallRequested, setPhoneCallRequested] = (0, _react.useState)(false);
  const [verifyingCode, setVerifyingCode] = (0, _react.useState)(false);
  const [resetKey, setResetKey] = (0, _react.useState)(0);
  const brand = (0, _context.useBrand)();
  const intl = (0, _reactIntl.useIntl)();
  const publishOtpResendCodeButtonClicked = (0, _usePublishPhoneVerificationOtpResendButtonClicked.default)();
  const publishOtpEditPhoneNumberButtonClicked = (0, _usePublishPhoneVerificationOtpEditPhoneNumberButtonClicked.default)();
  const publishPhoneCallOtpScreenDisplayed = (0, _usePublishPhoneVerificationPhoneCallOtpScreenDisplayed.default)();
  const {
    log
  } = (0, _context2.useLog)();
  (0, _react.useEffect)(() => {
    const timerId = setTimeout(() => setTimer(prev => Math.max(0, prev - 1)), 1000);
    return () => clearTimeout(timerId);
  }, [timer]);
  (0, _react.useEffect)(() => {
    if (phoneCallRequested) {
      const timer = setTimeout(() => {
        setPhoneCallRequested(false);
        setTimer(60);
      }, 2000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [phoneCallRequested]);
  (0, _react.useEffect)(() => {
    publishPhoneCallOtpScreenDisplayed((error === null || error === void 0 ? void 0 : error.message) === _errors.default.general ? "general_error" : undefined, phone.isVerified ? "verified" : "unverified");
    log(_events.PHONE_VERIFICATION_CALL_OTP_SCREEN_DISPLAYED, {});
  }, [error, publishPhoneCallOtpScreenDisplayed, phone.isVerified, log]);
  const handleRerequestPhoneCall = async () => {
    publishOtpResendCodeButtonClicked(phone.isVerified ? "verified" : "unverified");
    log(_events.PHONE_VERIFICATION_OTP_CODE_RESENT, {});
    setError(null);
    const token = await (0, _index.getAccessToken)({
      isSkyUsersV2: true
    });
    if (!token) {
      setError({
        message: _errors.default.general
      });
      return;
    }
    try {
      const res = await (0, _apiV.userPhoneChangeRequest)(token, {
        number: `${phone.callPrefix}${phone.phoneNumber}`,
        previousTransactionId: otpTransactionId !== null && otpTransactionId !== void 0 ? otpTransactionId : "",
        preferredCodeDeliveryMethod: "call",
        codeDeliveryConfirmBeforeCommunication: true
      });
      await (0, _apiV.userPhoneChangeConfirmCommunication)(token, {
        transaction_id: res.transaction_id
      });
      onOtpTransactionIdChange(res.transaction_id);
      setResetKey(prev => prev + 1);
      setPhoneCallRequested(true);
    } catch (error) {
      setError({
        message: _errors.default.general
      });
    }
  };
  const handleEdit = () => {
    publishOtpEditPhoneNumberButtonClicked(phone.isVerified ? "verified" : "unverified");
    onChangeScreen("phoneVerification");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center flex-col pt-[32px]",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Logo.default, {
        id: brand === null || brand === void 0 ? void 0 : brand.id,
        title: brand === null || brand === void 0 ? void 0 : brand.name,
        redirectUrl: "",
        url: brand === null || brand === void 0 ? void 0 : brand.base_url
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      dataTest: "MagicLogin-PhoneOtp",
      children: [_Heading || (_Heading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading2.default, {
        type: "title3",
        spaceAfter: "medium",
        align: "center",
        id: "magic-login-header",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.phone_verification.otp_verify.title"
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box2.default, {
        display: "flex",
        align: "center",
        direction: "column",
        children: [_Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text4.default, {
          size: "large",
          spaceAfter: "normal",
          align: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.otp_phone_call_verify.description"
          })
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
          type: "primarySubtle",
          iconRight: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Edit.default, {
            ariaLabel: intl.formatMessage({
              id: "account_v2.components.edit"
            })
          }),
          spaceAfter: "large",
          onClick: handleEdit,
          children: [phone.callPrefix, phone.phoneNumber]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OTPForm.default, {
        otpTransactionId: otpTransactionId,
        setVerifyingCode: setVerifyingCode,
        setPhoneVerified: setPhoneVerified,
        setError: setError,
        error: error,
        onChangeScreen: onChangeScreen,
        onPhoneVerificationFulfilled: onPhoneVerificationFulfilled,
        setPhoneVerificationRetryTime: setPhoneVerificationRetryTime,
        phone: phone
      }, resetKey), (error === null || error === void 0 ? void 0 : error.message) !== _errors.default.phoneNumberAlreadyVerified && !verifyingCode && !phone.isVerified && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box2.default, {
        display: "flex",
        justify: "center",
        align: "center",
        height: "44px",
        margin: {
          bottom: "800"
        },
        children: timer > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text4.default, {
          type: "secondary",
          children: [_FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.verify_modal.resend_code_timer"
          })), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedRelativeTime, {
            value: timer,
            unit: "second"
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
          type: "primary",
          onClick: handleRerequestPhoneCall,
          children: phoneCallRequested ? _Box || (_Box = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box2.default, {
            display: "flex",
            direction: "row",
            align: "center",
            justify: "center",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.phone_verification.otp_phone_call_verify.voice_call_requested"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Check.default, {
              ariaHidden: true
            })]
          })) : _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.otp_phone_call_verify.request_call"
          }))
        })
      }), !error && verifyingCode && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box2.default, {
        display: "flex",
        direction: "column",
        justify: "center",
        align: "center",
        margin: {
          bottom: "400"
        },
        className: "border border-blue-light",
        borderRadius: "200",
        children: [_Loading || (_Loading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading2.default, {
          ariaHidden: true
        })), _Text2 || (_Text2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text4.default, {
          type: "primary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.verify_modal.loading.verifying_number"
          })
        }))]
      }), !error && phone.isVerified && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box2.default, {
        display: "flex",
        direction: "column",
        justify: "center",
        align: "center",
        margin: {
          bottom: "400"
        },
        className: "border border-blue-light",
        borderRadius: "200",
        background: "productLight",
        padding: "400",
        children: [_CheckCircle || (_CheckCircle = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckCircle2.default, {
          ariaHidden: true,
          color: "success"
        })), _Text3 || (_Text3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text4.default, {
          type: "primary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.phone_verification.verify_modal.loading.phone_number_verified"
          })
        }))]
      })]
    })]
  });
};
var _default = exports.default = PhoneCallOtp;